<div
  class="dropdown"
  [class.opened]="isOpen$ | async"
  [uiDropdownWidth]="isOpen$ | async"
  [customDropdownListWidth]="customDropdownListWidth"
  (widthChange)="onWidthChange($event)"
  cdkOverlayOrigin
  #dropdownContainer="cdkOverlayOrigin"
>
  <div (click)="onOpen()">
    <ng-content select="[dropdown-value]"></ng-content>
  </div>
  <div class="dropdown-list">
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="dropdownContainer"
      [cdkConnectedOverlayOpen]="isOpen$ | async"
      [cdkConnectedOverlayPositions]="dropdownPositions"
      [cdkConnectedOverlayHasBackdrop]="false"
      (overlayOutsideClick)="onOutsideClick()"
      (positionChange)="onPositionChange($event)"
    >
      <div
        class="content"
        [ngStyle]="{
          transform: 'translateY(' + (dropdownOffsetY$ | async) + 'px)',
          width: (contentWidth$ | async) + 'px'
        }"
      >
        <ng-content select="[dropdown-list]"></ng-content>
      </div>
    </ng-template>
  </div>
</div>
